/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { deleteEntity, getEntity } from './pre-op-sign-in.reducer';

export const PreOpSignInDeleteDialog = () => {
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();
  const navigate = useNavigate();
  const { id } = useParams<'id'>();

  const [loadModal, setLoadModal] = useState(false);

  useEffect(() => {
    dispatch(getEntity(id));
    setLoadModal(true);
  }, []);

  const preOpSignInEntity = useAppSelector(state => state.preOpSignIn.entity);
  const updateSuccess = useAppSelector(state => state.preOpSignIn.updateSuccess);

  const handleClose = () => {
    navigate(`/pre-op-sign-in${pageLocation.search}`);
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(preOpSignInEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="preOpSignInDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="tinyMedicRestApp.preOpSignIn.delete.question">
        <Translate contentKey="tinyMedicRestApp.preOpSignIn.delete.question" interpolate={{ id: preOpSignInEntity.id }}>
          Are you sure you want to delete this PreOpSignIn?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="tm-confirm-delete-preOpSignIn" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PreOpSignInDeleteDialog;
